import React from 'react'

const EmployeesIcon: React.FC = () => (
	<svg xmlns="http://www.w3.org/2000/svg" width="22" height="18" fill="none" viewBox="0 0 22 18">
		<path
			className="stroke-current"
			strokeLinecap="round"
			strokeLinejoin="round"
			strokeWidth="2"
			d="M16 17h5v-2a3 3 0 00-5.356-1.857M16 17H6m10 0v-2c0-.656-.126-1.283-.356-1.857M6 17H1v-2a3 3 0 015.356-1.857M6 17v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M14 4a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM6 7a2 2 0 11-4 0 2 2 0 014 0z"
		></path>
	</svg>
)

export default EmployeesIcon
